import { Modal, Paper, Box, IconButton, Alert, useMediaQuery, useTheme } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Autoform } from './autoform';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import api from '../../hooks/useApi';
import CloseIcon from '@mui/icons-material/Close';
import DataContext from '../../hooks/FormsContext';
import jsonToFormData from '../../hooks/jsonToFormData';

const FetchForm = async (formName) => {
    try {
        const response = await api.get(`/api/CreateObjForms/${formName}/`);
        return response.data.form;
    } catch (error) {
        console.error('Error fetching form:', error);
        return null;
    }
}

export default function ModalForm({
    patchID = null,
    fieldClickedValue = null,
    formName,
    show,
    setShowModal,
    revalidator,
    fieldClicked,
    parentFormName
}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Определение мобильного экрана

    // Динамические стили для модального окна
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '90%' : '500px', // Адаптивная ширина
        p: 4,
    };
    const formHook = useForm(); // Call useForm unconditionally

    const [formError, setFormError] = useState(null);

    const handleSubmitForm = async (data) => {
//console.log((fieldClickedValue);
        try {
            const formData = jsonToFormData(data);

            const response = await api.post(`/api/${formName}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.status === 200 || response.status === 201) {
                // After successful submission, revalidate parent form

                if (patchID) {
                    try {
                        //console.log('patch request reached!');
                        // console.log({
                        //     patchId: patchID,
                        //     field: fieldClicked,
                        //     responseId: response.data.id,
                        //     parentFormName: parentFormName,
                        // })
                        const formData = new FormData();
                        if (fieldClickedValue)
                            if (fieldClickedValue instanceof Array)
                                fieldClickedValue.forEach(el => {
                                    formData.append(fieldClicked, el)
                                })
                            else
                                formData.append(fieldClicked, fieldClickedValue);
                        formData.append(fieldClicked, response.data.id); // Append fieldClicked as key and response.data.id as value
                        //console.log(formData);
                        const patch_url = `/api/${parentFormName}/${patchID}/`;
                        const patch_response = await api.patch(patch_url, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'  // Set Content-Type
                            }
                        });
                        //console.log(patch_response.data);
                        //console.log('patch request successful!');
                    }
                    catch (e) {
                        //console.log(e);
                        setFormError(e.message)
                    }
                }
                if (revalidator) {
                    revalidator.revalidate();
                }
                //setTriggerFetch(!triggerFetch);
                // Close the modal
                setShowModal(false);
            } else {
                alert('Unexpected response status:', response.status);
                console.error('Unexpected response status:', response.status);
            }
        } catch (error) {
            console.log(error);
            console.error('Error:', error.response ? error.response.data : error.message);
            setFormError(error.message)

        }
    }

    const [triggerFetch, setTriggerFetch] = useState(false);

    const handleClose = () => {
        setShowModal(false);
    }

    return (
        <Modal
            open={show}
        //onClose={handleClose}
        >
            <Box style={style}>
                <Paper sx={{ p: '20px', maxHeight: '80vh', overflowY: 'auto' }}>
                    <Box style={{ position: 'relative' }}>
                        <IconButton
                            style={{ position: 'absolute', right: 5, border: "1px solid lightgrey" }}
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </IconButton>
                        <h2>Додати </h2>
                        <AutoFormWrapper
                            formName={formName}
                            formHook={formHook}
                            handleSubmitForm={handleSubmitForm}
                            triggerFetch={triggerFetch}
                            setTriggerFetch={setTriggerFetch}
                        />
                        {formError && (
                            <Alert severity='error'>
                                Сталася помилка! {JSON.stringify(formError)}
                            </Alert>
                        )
                        }
                    </Box>
                </Paper>
            </Box>
        </Modal>
    )
}

function AutoFormWrapper({ formName, formHook, handleSubmitForm, triggerFetch, setTriggerFetch }) {
    const [form, setForm] = useState(null);
    const formContext = useContext(DataContext);
    const formFromContext = formContext ? formContext[formName] : null;

    /*console.log({
        formContext, formFromContext, formName
    })*/

    useEffect(() => {
        if (formFromContext) {
            setForm(formFromContext);
        }
        else {
            const fetchFormData = async () => {
                const formData = await FetchForm(formName);
                setForm(formData);
            };
            fetchFormData();
        }
    }, [formName, triggerFetch]);

    if (!form) {
        return <p>Завантаження форми...</p>;
    }

    return (
        <Autoform
            fields={form}
            formHook={formHook}
            onSubmit={handleSubmitForm}
            className={'modalFormWindow'}
            submitButton='Додати'
            setTriggerFetch={setTriggerFetch}
        />
    );
}